import { useRef, useState } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { CloudinaryImage } from "../../../../Atoms/Cloudinary";
import ModalScreen from "../../../../Atoms/ModalScreen";
import styles from "./RecentTourPhotos.module.scss";

const responsive = {
  desktop: {
    breakpoint: {
      max: 3000,
      min: 1024,
    },
    items: 1,
  },
  mobile: {
    breakpoint: {
      max: 464,
      min: 0,
    },
    items: 1,
  },
  tablet: {
    breakpoint: {
      max: 1024,
      min: 200,
    },
    items: 1,
  },
};

interface RecentPhotos {
  recentPhotos: string[];
}

function RecentTourPhotos({ recentPhotos }: RecentPhotos) {
  const carouselRef = useRef<Carousel>(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [viewingImage, setViewingImage] = useState({
    src: "",
    modalOpen: false,
  });

  const thumbs = recentPhotos.slice(0, 6).map((image, index) => (
    <div
      key={index}
      onClick={() => {
        setCurrentSlide(index);
        carouselRef.current.goToSlide(index);
      }}
      className={`${styles.Thumbnail} ${
        currentSlide === index && styles.active
      }`}
    >
      <CloudinaryImage
        src={image}
        transformations={["w_100", "h_65", "c_fill"]}
      />
    </div>
  ));

  return (
    <>
      {recentPhotos.length > 0 && (
        <>
          <div className={styles.RecentPhotosWrapper}>
            <div className={styles.ThumbnailsWrapper}>{thumbs}</div>
            <Carousel
              slidesToSlide={1}
              containerClass={styles.RecentTourPhotosCarousel}
              responsive={responsive}
              centerMode={false}
              ref={carouselRef}
              afterChange={(_, { currentSlide }) => {
                setCurrentSlide(currentSlide);
              }}
            >
              {recentPhotos.map((image, index) => (
                <div
                  key={index}
                  className={styles.ImageHolder}
                  onClick={() =>
                    setViewingImage({
                      modalOpen: true,
                      src: image,
                    })
                  }
                >
                  <CloudinaryImage
                    src={image}
                    transformations={["h_440", "c_fill"]}
                  />
                </div>
              ))}
            </Carousel>
            {viewingImage.modalOpen && (
              <ModalScreen
                openVideo={viewingImage.modalOpen}
                onClose={() => {
                  setViewingImage({ ...viewingImage, modalOpen: false });
                }}
              >
                <div className={styles["ViewImageModalContainer"]}>
                  <div>
                    <CloudinaryImage
                      src={viewingImage.src}
                      transformations={["w_300", "c_fill"]}
                    />
                  </div>
                </div>
              </ModalScreen>
            )}
          </div>
        </>
      )}
    </>
  );
}

export default RecentTourPhotos;
